import React from 'react';
import { FormInstance } from 'antd';
import {
  Input,
  InputNumber,
  Modal,
} from 'UI';

import {
  FormContainer,
  BaseFormItem,
  InlineButton,
} from './style';

export interface VehicleFormData {
  name: string
  plate: string
  capacity: number
}

interface VehicleModalProps {
  formHandler: FormInstance
  onSubmit(data: unknown): void
  onCancel(): void
  curVehicle?: VehicleFormData
  isLoading: boolean
  isVisible: boolean
}

const VehicleModal = ({
  formHandler,
  onSubmit,
  onCancel,
  curVehicle,
  isLoading,
  isVisible,
}: VehicleModalProps): JSX.Element => (
  <Modal
    visible={isVisible}
    title={curVehicle ? 'Editar veículo' : 'Novo veículo'}
    destroyOnClose
    onCancel={onCancel}
    afterClose={onCancel}
    zIndex={90}
    footer={[
      <InlineButton
        key="cancel"
        onClick={onCancel}
        type="ghost"
      >
        Cancelar
      </InlineButton>,
      <InlineButton
        key="submit"
        onClick={onSubmit}
        disabled={isLoading}
        loading={isLoading}
      >
        Salvar veículo
      </InlineButton>,
    ]}
  >
    <FormContainer
      layout="vertical"
      form={formHandler}
      requiredMark={false}
      onFinish={onSubmit as (val: unknown) => void}
    >
      <BaseFormItem
        label="Nome"
        name="name"
        rules={[
          {
            required: true,
            message: 'Insira um nome',
          },
        ]}
        initialValue={curVehicle?.name}
      >
        <Input disabled={isLoading} />
      </BaseFormItem>
      <BaseFormItem
        label="Placa"
        name="plate"
        rules={[
          {
            required: true,
            message: 'Insira uma placa',
          },
        ]}
        initialValue={curVehicle?.plate}
      >
        <Input disabled={isLoading} />
      </BaseFormItem>
      <BaseFormItem
        label="Capacidade"
        name="capacity"
        rules={[
          {
            required: true,
            message: 'Insira uma capacidade',
          },
        ]}
        initialValue={curVehicle?.capacity}
      >
        <InputNumber min={0} disabled={isLoading} />
      </BaseFormItem>
    </FormContainer>
  </Modal>
);

VehicleModal.defaultProps = {
  curVehicle: undefined,
};

export default VehicleModal;
